import { serverApiClient, withClientIdHeader } from '@/services/http-client';

/** Participants of a Jitsi meeting, as sent to the GUI server's link generator. */
export interface JitsiLinksRequest {
  ownerEmail: string;
  ownerName: string;
  memberEmail: string;
  memberName: string;
  roomName?: string;
}

/** Signed join URLs returned by `/server/api/jitsi/links`. */
export interface JitsiLinksResponse {
  ownerLink: string;
  memberLink: string;
}

/**
 * Asks the GUI server to sign owner and member Jitsi join URLs for a tenant.
 */
export async function createJitsiLinks(clientId: string, body: JitsiLinksRequest): Promise<JitsiLinksResponse> {
  const { data } = await serverApiClient.post<JitsiLinksResponse>('jitsi/links', body, withClientIdHeader(clientId));
  return data;
}
